import { OnInit, OnDestroy } from '@angular/core';
import { TokenManager } from '../Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../objects/Globals';
import { WorkspaceService } from '../services/workspace.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoginService } from '../services/login.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConversationService } from '../services/conversation.service';
var LayoutWorkspaceComponent = /** @class */ (function () {
    function LayoutWorkspaceComponent(workspaceService, loginService, deviceService, tokenManager, router, globals, route, themeSettingService, conversationService) {
        this.workspaceService = workspaceService;
        this.loginService = loginService;
        this.deviceService = deviceService;
        this.tokenManager = tokenManager;
        this.router = router;
        this.globals = globals;
        this.route = route;
        this.themeSettingService = themeSettingService;
        this.conversationService = conversationService;
        this.reportGroupList = new Array();
        this.isBusy = false;
        this.msGridColumns = "";
        this.msGridRows = "";
        this.gridRowsDefaultArray = [];
        this.reportGridHeightArray = [];
        this.isMobile = false;
        this.isMobile = deviceService.isMobile();
    }
    LayoutWorkspaceComponent.prototype.clickout = function (event) {
        var element = event.target;
        if (element.classList.contains('auto-reply')) {
            this.searchGlobal(element.getAttribute('data-value'));
        }
    };
    LayoutWorkspaceComponent.prototype.ngOnDestroy = function () {
        //  this.sub.unsubscribe();
    };
    LayoutWorkspaceComponent.prototype.searchGlobal = function (value) {
        var _this = this;
        this.isBusy = true;
        if (value) {
            this.conversationService.converse(value).subscribe(function (result) {
                var resultObject = JSON.parse(result);
                _this.isBusy = false;
                if (resultObject.ReturnType == "0") {
                    if (resultObject.Arguments) {
                        var path = [];
                        resultObject.Arguments.forEach(function (element) {
                            path.push(element);
                        });
                        ;
                        _this.router.navigate(path);
                    }
                }
            }, function (error) {
                _this.isBusy = false;
            });
        }
        else {
            this.isBusy = false;
        }
    };
    LayoutWorkspaceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        this.tokenManager.store("BRNCurrentRoute", this.router.url);
        if (this.globals == null) {
            this.router.navigate(['/', '/']);
        }
        ;
        if (this.globals.Session == null) {
            this.router.navigate(['/', '/']);
        }
        ;
        if (this.globals.Session) {
            var page = this.route.snapshot.paramMap.get('page');
            this.isBusy = true;
            this.workspaceService.getEPICPage(page, this.isMobile).subscribe(function (result) {
                _this.isBusy = false;
                _this.pageContent = JSON.parse(result);
                // console.log(this.pageContent);
                _this.gridColumns = "repeat(" + _this.pageContent.PageWidth + ", 1fr)";
                for (var i = 0; i < _this.pageContent.PageWidth; i++) {
                    _this.msGridColumns += "1fr ";
                }
                if (_this.pageContent.PageIsFixedSize) {
                    document.querySelectorAll('.body-wrapper').item(0).classList.remove("scroll");
                    _this.gridRowsDefaultArray = Array(_this.pageContent.PageHeight).fill("1fr");
                    _this.gridRows = "repeat(" + _this.pageContent.PageHeight + ", 1fr)";
                    for (var i = 0; i < _this.pageContent.PageHeight; i++) {
                        _this.msGridRows += "1fr ";
                    }
                }
                else {
                    document.querySelectorAll('.body-wrapper').item(0).classList.add("scroll");
                    _this.gridRows = "repeat(" + _this.pageContent.PageHeight + ", 50px)";
                    for (var i = 0; i < _this.pageContent.PageHeight; i++) {
                        _this.msGridRows += "50px ";
                    }
                }
                var objGroup = [];
                var index = 0;
                _this.sort(_this.pageContent.Content);
                // console.log(this.pageContent.Content);
                _this.pageContent.Content.forEach(function (obj) {
                    if (obj.PositionX == 0) {
                        obj.PositionX = 1;
                    }
                    if (obj.PositionY == 0) {
                        obj.PositionY = 1;
                    }
                    objGroup.push({
                        index: index,
                        groupId: obj.EPICContentId,
                        positionX: obj.PositionX,
                        positionY: obj.PositionY
                    });
                    var posX = obj.PositionX;
                    var posY = obj.PositionY;
                    // this.promiseGetEpicGroup(obj.EPICContentId).then(result => {
                    //   var reportGroup:ReportGroup = JSON.parse(result);
                    //   reportGroup.StartRow = posY == 0 ? 1 : posY;
                    //   reportGroup.StartColumn = posX == 0 ? 1 : posX;
                    //   this.reportGroupList.splice(index, 0, reportGroup);
                    // })
                    // this.getEPICGroup(obj.EPICContentId, obj.PositionX, obj.PositionY);
                    index++;
                });
                //this.getAllEPICGroup(objGroup);
            });
        }
    };
    LayoutWorkspaceComponent.prototype.setReportGroup = function (reportGroup) {
        this.reportGroupList.push(reportGroup);
    };
    LayoutWorkspaceComponent.prototype.getGridConfig = function (groupId, type) {
        if (this.reportGroupList.length > 0) {
            var i = this.reportGroupList.find(function (x) { return x.GroupId == groupId; });
            if (i) {
                switch (type) {
                    case "startColumn":
                        return i.StartColumn;
                    case "startRow":
                        return i.StartRow;
                    case "height":
                        return i.Height;
                    case "width":
                        return i.Width;
                }
            }
        }
    };
    LayoutWorkspaceComponent.prototype.promiseGetEpicGroup = function (groupId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.workspaceService.getEPICGroup(_this.pageContent.EPICPageId, groupId).subscribe(function (result) {
                resolve(result);
            });
        });
    };
    LayoutWorkspaceComponent.prototype.sort = function (objGroup) {
        return objGroup.sort(function (a, b) {
            if (a.PositionX > b.PositionX) {
                return 1;
            }
            if (a.PositionX < b.PositionX) {
                return -1;
            }
            if (a.PositionY > b.PositionY) {
                return 1;
            }
            if (a.PositionY < b.PositionY) {
                return -1;
            }
            return 0;
        });
    };
    LayoutWorkspaceComponent.prototype.setGridRows = function (rowSizeArray, startRow) {
        var _this = this;
        var ultimateRows = "";
        var msUltimateRows = "";
        var indexArray = [];
        // var startRow = reportGroup.StartRow;
        rowSizeArray.forEach(function (element) {
            indexArray.push({ index: startRow - 1, size: element });
            startRow++;
        });
        indexArray.forEach(function (obj) {
            _this.gridRowsDefaultArray[obj.index] = obj.size;
        });
        var array = this.gridRowsDefaultArray.map(function (item) { return item; }).filter(function (value, index, self) { return self.indexOf(value) === index; }); //remove duplicates
        if (this.pageContent.PageIsFixedSize) {
            array.forEach(function (element) {
                ultimateRows = ultimateRows + "repeat(" + _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length + ", " + element + ") ";
                for (var i = 0; i < _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length; i++) {
                    msUltimateRows = msUltimateRows + element + " ";
                }
            });
            this.gridRows = ultimateRows;
            this.msGridRows = msUltimateRows;
        }
        else {
            this.reportGridHeightArray.push(array);
            if (this.reportGridHeightArray.length == this.pageContent.Content.length) {
                var stuff = this.reportGridHeightArray[this.reportGridHeightArray.length - 1];
                stuff.forEach(function (element) {
                    var value = element;
                    if (element == "minmax(0px, 1fr)") {
                        value = "50px";
                    }
                    ultimateRows = ultimateRows + "repeat(" + _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length + ", " + value + ") ";
                    for (var i = 0; i < _this.gridRowsDefaultArray.filter(function (x) { return x == element; }).length; i++) {
                        msUltimateRows = msUltimateRows + element + " ";
                    }
                    _this.gridRows = ultimateRows;
                    _this.msGridRows = msUltimateRows;
                });
            }
        }
    };
    LayoutWorkspaceComponent.prototype.getEPICGroup = function (groupId, positionX, positionY) {
        var _this = this;
        this.workspaceService.getEPICGroup(this.pageContent.EPICPageId, groupId).subscribe(function (result) {
            _this.reportGroup = JSON.parse(result);
            if (positionX == 0) {
                positionX = 1;
            }
            if (positionY == 0) {
                positionY = 1;
            }
            _this.reportGroup.StartRow = positionY;
            _this.reportGroup.StartColumn = positionX;
            _this.reportGroupList.push(_this.reportGroup);
        });
    };
    LayoutWorkspaceComponent.prototype.getAllEPICGroup = function (obj) {
        var _this = this;
        var groupIds = [];
        obj.forEach(function (element) {
            groupIds.push(element.groupId);
        });
        var reportGroup = [];
        this.workspaceService.getEPICGroupAll(this.pageContent.EPICPageId, groupIds).subscribe(function (results) {
            var i = 0;
            for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                var result = results_1[_i];
                var report;
                report = JSON.parse(result);
                report.StartRow = obj.find(function (x) { return x.index == i; }).positionY;
                report.StartColumn = obj.find(function (x) { return x.index == i; }).positionX;
                reportGroup.push(report);
                i++;
            }
            _this.reportGroupList = reportGroup;
        });
    };
    return LayoutWorkspaceComponent;
}());
export { LayoutWorkspaceComponent };
